<template>
  <div style="display:none;">
    <div id="printMe">
      <div class="overlay"></div>
      <div
        v-for="product in productInfos"
        v-bind:key="product.id"
        class="A4Type2 printArea"
        style="width : 60mm;height: 46.3mm; text-align:center; float: left; border: 1px solid; border-color:white;  margin-right:2.3mm;padding-top:1mm;"
      >
        <div v-if="product.distinguish != 'distinguish'">
          <table style="width : 60mm; text-align:center;margin-top:3mm">
            <tr style="width : 60mm">
              <td>
                <p style="font-size: 12px; padding:0px; margin:0px;">
                  [정품인증코드]
                </p>
              </td>
            </tr>
            <tr style="width : 60mm">
              <td>
                <p style="font-size: 12px; padding:0px; margin:0px;" class="subTitleBold">
                  {{ product.authCode }}
                </p>
              </td>
            </tr>
          </table>

          <table style="margin:auto;">
            <tr style="width : 60mm; margin:auto;">
              <td style="margin:auto;">
                <tr>
                  <td style="padding:0px; margin:0px; margin:auto;">
                    <p class="titleBold" style="font-size: 30px; padding:0px; margin:0px;text-align:center; line-height:15px;">
                      正品
                    </p>
                  </td>

                  <td rowspan="4" style="padding-left: 4mm;">
                    <qrcode-vue :value="product.url" :size="QrCodeSize" level="H" :renderAs="renderAs"></qrcode-vue>
                  </td>
                </tr>

                <tr>
                  <td style="padding:0px; margin:0px;">
                    <p style="font-size: 11px; padding:0px; margin:0px;text-align:center; line-height: 5px;">
                      정품을
                    </p>
                  </td>
                </tr>

                <tr>
                  <td style="padding:0px; margin:0px;">
                    <p style="font-size: 11px; padding:0px; margin:0px;text-align:center; line-height: 5px;">
                      인증합니다
                    </p>
                  </td>
                </tr>
              </td>
            </tr>
          </table>

          <table style="width : 60mm; text-align:center;padding-top: 0mm;">
            <tr>
              <td style="width : 60mm; font-size: 12px; padding:0px; margin:-top:3mm;" v-html="descriptionContent"></td>
            </tr>
          </table>
        </div>
        <div v-else>
          <table>
            <p
              style="margin:0px; padding:0px; width : 55mm; padding-right:2mm; padding-left:2mm; padding-top:5mm; padding-bottom:2mm; text-align: left;"
            >
              인쇄매수 : {{ product.variantPrintCount }} ▼
            </p>
            <div style="width : 52mm;">
              <p
                style="margin:0px; padding:0px; width : 55mm; padding-top:2mm; padding-left:2mm; padding-right:2mm; font-size: 11px; text-align: left; overflow: hidden; text-overflow: ellipsis;display:-webkit-box; -webkit-line-clamp:2;-webkit-box-orient:vertical;"
              >
                {{ product.productName }}
              </p>
              <p
                style="margin:0px; padding:0px; width : 55mm;  padding-left:2mm; padding-right:2mm; font-size: 11px; text-align: left; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; text-align: left"
              >
                옵션 : {{ product.variantName }}
              </p>
              <p style="margin:0px; padding:0px; width : 55mm;  padding-left:2mm; padding-right:2mm; font-size: 11px; text-align: left;">
                상품코드 : {{ product.productCode }}
              </p>
              <p
                style="margin:0px; padding:0px; width : 55mm;  padding-bottom:2mm; padding-left:2mm;  padding-right:2mm; font-size: 11px; text-align: left;"
              >
                품목코드 : {{ product.variantCode }}
              </p>
            </div>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import Vue from "vue";
import QrcodeVue from "qrcode.vue";
import VueHtmlToPaper from "vue-html-to-paper";
import CommonMixin from "@/mixins/CommonMixin.js";
import store from "../../../../store";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=no", "scrollbars=yes"],
  styles: ["/style/print.css"],
};

Vue.use(VueHtmlToPaper);

export default {
  data() {
    return {
      productInfos: [],
      QrCodeValue: "https://" + store.state.mallId + ".cafe24.com",
      QrCodeSize: 65,
      renderAs: "svg",
      tableDatas: [],
      listCount: 0,
      descriptionContent: "<p style='text-align:center; padding-top: 2mm;'>QR 코드를 스캔해주세요</p>",
    };
  },
  components: {
    QrcodeVue,
  },
  mixins: [CommonMixin],
  methods: {
    btnOnClick: function() {
      this.tableDatas.push({
        itemname: "item",
        quantity: 1,
        sellingprice: 55,
        amount: 55,
      });
    },
    qrPrint: async function() {
      await this.$htmlToPaper("printMe", options);
    },
    qrCodePringttingContents: async function(data) {
      this.productInfos = [];
      let shop_url = sessionStorage.getItem(`${this.$store.state.mallId}_domain`);
      if (this.$store.state.mallType !== "imweb") {
        if (!shop_url) {
          shop_url = "https://" + this.$store.state.mallId + ".cafe24.com";
        }
      }
      for (var productCode in data) {
        for (var variantCode in data[productCode]) {
          let distinguishData = {
            distinguish: "distinguish",
            productName: data[productCode][variantCode][0][0].product_name.replace(/<[^>]+>/gi, ""),
            variantName: data[productCode][variantCode][0][0].variant_name,
            productCode: productCode,
            variantCode: variantCode,
            variantPrintCount: 0,
          };
          let idx = this.productInfos.push(distinguishData);
          for (var i = 0; i < data[productCode][variantCode].length; i++) {
            for (var j = 0; j < data[productCode][variantCode][i][0].print_count; j++) {
              let serialNumber = data[productCode][variantCode][i][0].serial_number;
              let encrySerialNumber = btoa(encodeURI(data[productCode][variantCode][i][0].serial_number));

              // URL 생성 로직 개선
              let _url = "";
              if (this.$store.state.mallType !== "imweb") {
                _url = shop_url + "/registration/index.html";
              } else {
                _url = shop_url + "/registration";
              }

              let QrData = {
                id: this.listCount,
                url: _url + "?authQrCode=" + encrySerialNumber,
                authCode: serialNumber,
              };
              this.productInfos.push(QrData);
              this.listCount++;
              this.productInfos[idx - 1].variantPrintCount++;
            }
          }
        }
      }
    },
    setQrPrintList: async function(data) {
      let getCount = Object.keys(data).length;
      if (!getCount) {
        alert("선택된 상품이 없습니다.");
        return false;
      }
      await this.qrCodePringttingContents(data);

      if (this.listCount == 0) {
        alert("인쇄수량이 없습니다.");
        return false;
      }
      this.qrPrint();
    },
    /**
     * QR 코드 인쇄 설정 정보 가져오기
     */
    getQrcodeSettingInfo: async function() {
      try {
        let data = await M.api(M.entry("/get/print"), {});

        //문구 설정 체크
        if (data.print_description) {
          this.descriptionContent = "<p style='margin-top: 3mm;'>" + data.print_description + "</p>";
          //이미지 설정 체크
        } else if (localStorage.imageUrlInfo) {
          this.descriptionContent = "<img src=" + localStorage.imageUrlInfo + " />";
          //default
        } else {
          this.descriptionContent = "<p style='text-align:center; margin-top: 3mm;'>QR 코드를 스캔해주세요</p>";
        }
      } catch (e) {
        //console.log(e);
      }
    },
  },
  created: async function() {
    /**
     * QR 코드 설정 데이터 가져오기
     */
    await this.getQrcodeSettingInfo();
    //같은 자식 컴포넌트로 부터 setList 을 emit 한 함수를 on 으로 받아 setProductList 메소드 호출
    this.eventHub.$on("setQrPrintList", this.setQrPrintList);
  },
};
</script>
